import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import DatePicker, { registerLocale } from 'react-datepicker';
import ContentHeader from '../../components/ContentHeader';
import Loader from "../../components/Loader";
import axios from "axios";
import Swal from "sweetalert2";
import $ from 'jquery';
import 'react-datepicker/dist/react-datepicker.css'
import es from "date-fns/locale/es";
import 'select2';
import 'select2/dist/css/select2.min.css';
import { Tooltip } from 'bootstrap';
registerLocale('es', es);

const Packages = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState([]);
    const [branchs, setBranchs] = useState([]);
    const [origins, setOrigins] = useState([]);
    const [destinations, setDestinations] = useState([]);
    const [branch_id, setBranchId] = useState(0);
    const [schedule_id, setScheduleId] = useState([]);
    const [origin_id, setOriginId] = useState(0);
    const [destination_id, setDestinationId] = useState(0);
    const [origin, setOrigin] = useState('');
    const [destination, setDestination] = useState('');
    const [description_package, setDescripcionPackage] = useState('');
    const [sender, setSender] = useState('');
    const [addressee, setAddressee] = useState('');
    const [email, setEmail] = useState('');
    const [price, setPrice] = useState('');
    const [phone, setPhone] = useState('');
    const [card_payment, setCardPayment] = useState("2")
    const [cardPaymentTransfer, setCardPaymentTransfer] = useState("2")
    const [declared, setDeclared] = useState('');
    const [advance, setAdvance] = useState('');
    const [date, setDate] = useState(new Date());
    const [date_max, setDateMax] = useState(new Date);
    const [dateSelect, setDateSelect] = useState('');
    const [timeSelect, setTimeSelect] = useState('');
    const [courtesy, setCourtesy] = useState(1);
    const [payment_status, setPaymentStatus] = useState(2);
    const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT;
    const TITLEALERT = process.env.REACT_APP_TITLE_ALERT;

    const formatCurrency = (value) => {
        if (!value) return '$0.00 MXN';
        const number = parseFloat(value);
        return isNaN(number) ? '$0.00 MXN' : `$${number.toFixed(2)} MXN`;
    };

    const unformatCurrency = (value) => {
        return value ? value.replace(/[^0-9.]/g, '') : '';
    };

    const handleCurrencyInput = (value, setter) => {
        const numericValue = unformatCurrency(value);
        setter(numericValue);
    };

    useEffect(() => {
        getAllBranchs();
        getAllOrigins();
        const date = new Date();
        date.setDate(date.getDate() + 7);
        setDateMax(date);
        setTimeout(() => {
            $('.select2').select2({ width: "100%", placeholder: "Seleccione" });
        }, 100);
        // Initialize tooltips
        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new Tooltip(tooltipTriggerEl);
        });
    }, []);

    // Quick search: selecciona rama, origen y destino por ID, luego busca
    const handleQuickSearch = async (branchId, originId, destinationId) => {
        // Seleccionar rama
        setBranchId(branchId);
        $('#branch_id').val(branchId).trigger('change');
        
        // Seleccionar origen
        setOriginId(originId);
        $('#origin_id').val(originId).trigger('change');
        
        // Cargar destinos para el origen seleccionado
        await getAllDestinations(originId);
        
        // Seleccionar destino
        setDestinationId(destinationId);
        setTimeout(() => {
            $('#destination_id').val(destinationId).trigger('change');
        }, 100);
        
        // Establecer fecha a hoy
        const today = new Date();
        setDate(today);
        
        // Ejecutar búsqueda
        setTimeout(() => {
            handleSearch({ preventDefault: () => {} });
        }, 200);
    };

    $('#branch_id').on("change", function (e) {
        setBranchId(e.target.value);
    });

    $('#origin_id').on("change", function (e) {
        setOriginId(e.target.value);
        getAllDestinations(e.target.value);
    });

    $('#destination_id').on("change", function (e) {
        setDestinationId(e.target.value);
    });

    const handleSearch = async (e) => {
        e.preventDefault();
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");
        const dateFormat = year + '-' + month + '-' + day;
        const branchId = $('#branch_id').val();
        const originId = $('#origin_id').val();
        const destinationId = $('#destination_id').val();
        const form = new FormData();
        form.append('branch_id', branchId);
        form.append('origin_id', originId);
        form.append('destination_id', destinationId);
        form.append('date', dateFormat);
        setLoading(true);
        await axios.post(ENDPOINT + 'search-trip-package', form)
            .then(response => {
                setSearch(response.data.data);
                var table = $('.main').DataTable();
                table.destroy();
                setTimeout(() => {
                    $('.main').DataTable({
                        searching: true,
                        destroy: true,
                        retrieve: true,
                        pageLength: 10,
                        responsive: false,
                        autoWidth: true,
                        paging: true,
                        ordering: true,
                        sortable: true,
                        processing: false,
                        serverSide: false,
                        bInfo: true,
                        language: {
                            "decimal": "",
                            "emptyTable": "",
                            "info": "Mostrando _START_ a _END_ de _TOTAL_ registros",
                            "infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
                            "infoFiltered": "(filtrado de un total de _MAX_ registros)",
                            "infoPostFix": "",
                            "thousands": ",",
                            "lengthMenu": "Mostrar _MENU_ registros",
                            "loadingRecords": "Cargando...",
                            "processing": "Procesando...",
                            "search": "Buscar:",
                            "paginate": {
                                "first": "<i class='fa-solid fa-circle-chevron-left'></i>",
                                "last": "<i class='fa-solid fa-circle-chevron-right'></i>",
                                "next": "<i class='fas fa-arrow-circle-right'></i>",
                                "previous": "<i class='fas fa-arrow-circle-left'></i>"
                            },
                            "zeroRecords": "No hay registros",
                            "searchPlaceholder": "Buscar...",
                        },
                    });
                    setLoading(false);
                }, 100);
            }).catch(function (error) {
                setLoading(false);
                Swal.fire({
                    icon: 'error',
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: true,
                    timer: 3000,
                    html: '<div class="text-custom-alert">' + error.response.data.msg + '</div>',
                    showClass: { popup: 'animate__animated animate__fadeInDown' },
                    hideClass: { popup: 'animate__animated animate__fadeOutUp' }
                })
            });
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const form = new FormData();
        const user = JSON.parse(localStorage.getItem('dataUser'));
        const user_id = user.user_id;
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");
        const date_send = year + '-' + month + '-' + day;
        form.append('schedule_id', schedule_id);
        form.append('branch_id', branch_id);
        form.append('origin_id', origin_id);
        form.append('destination_id', destination_id);
        form.append('user_id', user_id);
        form.append('date_send', date_send);
        form.append('time_send', timeSelect);
        form.append('description_package', description_package);
        form.append('price', price);
        form.append('advance', advance);
        form.append('sender', sender);
        form.append('addressee', addressee);
        form.append('email', email);
        form.append('phone', phone);
        form.append('card_payment', card_payment);
        form.append('cardPaymentTransfer', cardPaymentTransfer);
        form.append('payment_status', payment_status);
        form.append('courtesy', courtesy);
        form.append('declared', declared);
        setLoading(true);
        $("#closemodal").trigger("click");
        await axios.post(ENDPOINT + 'save-package', form).then(response => {
            Swal.fire({
                icon: 'success',
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: false,
                timer: 3000,
                html: '<div class="text-custom-alert">' + response.data.msg + '</div>',
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' }
            });
            handlePrint(response.data.data.package_id);
        }).catch(function (error) {
            Swal.fire({
                icon: 'error',
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: true,
                html: '<div class="text-custom-alert">' + error.response.data.msg + '</div>',
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' }
            })
        });
    }

    const getAllBranchs = async () => {
        setLoading(true);
        const response = await axios.get(ENDPOINT + 'get-all-branchs-package');
        const branchsArray = response.data.data.map(function (element) {
            return {
                label: element.name,
                value: element.branch_id,
            };
        });
        setBranchs(branchsArray);
        setLoading(false);
    };

    const getAllOrigins = async () => {
        const response = await axios.get(ENDPOINT + 'get-all-origins-package');
        const originsArray = response.data.data.map(function (element) {
            return {
                label: element.name,
                value: element.destination_id,
            };
        })
        setOrigins(originsArray);
    };

    const getAllDestinations = async (origin_id) => {
        setDestinations([]);
        setLoading(true);
        const response = await axios.get(ENDPOINT + 'get-all-destinations-package/' + origin_id);
        const destinationsArray = response.data.data.map(function (element) {
            return {
                label: element.name,
                value: element.destination_id,
            };
        })
        setDestinations(destinationsArray);
        setLoading(false);
        return destinationsArray;
    };

    const handleChooseTrip = async (schedule_id, origin, destination, date, time) => {
        setScheduleId(schedule_id);
        setOrigin(origin);
        setDestination(destination);
        setDateSelect(date);
        setTimeSelect(time);
    };

    const cancelPackage = () => {
        setBranchId(0);
        setScheduleId([]);
        setOriginId(0);
        setDestinationId(0);
        setOrigin('');
        setDestination('');
        setDescripcionPackage('');
        setSender('');
        setAddressee('');
        setEmail('');
        setPrice('');
        setPhone('');
        setDeclared('');
        setAdvance('');
        setDate(new Date());
        setDateSelect('');
        setTimeSelect('');
        setCourtesy(1);
        setPaymentStatus(2);
    };

    const handlePrint = async (id) => {
        setLoading(true);
        const user = JSON.parse(localStorage.getItem('dataUser'));
        const user_id = user.user_id;
        const form = new FormData();
        form.append("id", id);
        form.append("user_id", user_id);
        const response = await axios.post(ENDPOINT + 'print-pdf-package', form, { responseType: "blob" });
        const url = window.URL.createObjectURL(response.data);
        window.open(url, '_blank');
        navigate('/listado-paquetes');
        setLoading(false);
        cancelPackage();
    };

    const handleChangeCourtesy = (e) => {
        setCourtesy(e.target.value);
    };

    const handleChangePaymentStatus = (e) => {
        setPaymentStatus(e.target.value);
    };

    const handleChangeCardPaymentStatus = (e) => {
        setCardPayment(e.target.value);
    };

    const handleChangeCardPaymentTransferStatus = (e) => {
        setCardPaymentTransfer(e.target.value);
    };

    const formatDate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const formatTime = (timeString) => {
        if (!timeString) return "";
        const [hours, minutes] = timeString.split(':');
        const date = new Date();
        date.setHours(hours);
        date.setMinutes(minutes);
        const formattedMinutes = date.getMinutes().toString().padStart(2, '0');
        const ampm = date.getHours() >= 12 ? 'PM' : 'AM';
        const hours12 = (date.getHours() % 12) || 12;
        const formattedHours12 = hours12.toString().padStart(2, '0');
        return `${formattedHours12}:${formattedMinutes} ${ampm}`;
    };

    return (
        <>
            {loading && <Loader />}
            <div className="modal fade" id="modal-default" aria-labelledby="modal-default" data-bs-backdrop="static" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                        <div className="modal-header bg-header-modal">
                            <h4 className="modal-title">Datos del paquete</h4>
                            <button onClick={cancelPackage} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <form id="formulario" onSubmit={handleSubmit}>
                            <div className="modal-body">
                                <div className="add-package-form-header">
                                    <h3 className="add-package-form-title">Agregar Nuevo Paquete</h3>
                                    <p className="add-package-form-subtitle">Complete los datos para agregar un nuevo paquete al sistema</p>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-sm-12">
                                        <div className="form-group">
                                            <label htmlFor="description_package" className="col-form-label col-form-label-sm">
                                                Descripción del paquete <span className="add-package-required">*</span>
                                            </label>
                                            <input
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese descripción del paquete"
                                                type="text"
                                                value={description_package}
                                                onChange={(e) => setDescripcionPackage(e.target.value)}
                                                id="description_package"
                                                name="description_package"
                                                required
                                            />
                                            <span className="add-package-field-hint">Describa el contenido del paquete</span>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="form-group">
                                            <label htmlFor="sender" className="col-form-label col-form-label-sm">
                                                Nombre del remitente <span className="add-package-required">*</span>
                                            </label>
                                            <input
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese nombre del remitente"
                                                type='text'
                                                value={sender}
                                                onChange={(e) => setSender(e.target.value)}
                                                id="sender"
                                                name="sender"
                                                required
                                            />
                                            <span className="add-package-field-hint">Ingrese el nombre del remitente</span>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="form-group">
                                            <label htmlFor="addressee" className="col-form-label col-form-label-sm">
                                                Nombre del destinatario <span className="add-package-required">*</span>
                                            </label>
                                            <input
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese nombre del destinatario"
                                                type='text'
                                                value={addressee}
                                                onChange={(e) => setAddressee(e.target.value)}
                                                id="addressee"
                                                name="addressee"
                                                required
                                            />
                                            <span className="add-package-field-hint">Ingrese el nombre del destinatario</span>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="form-group">
                                            <label htmlFor="email" className="col-form-label col-form-label-sm">
                                                Correo electrónico
                                            </label>
                                            <input
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese correo electrónico (Opcional)"
                                                type='email'
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                id="email"
                                                name="email"
                                            />
                                            <span className="add-package-field-hint">Ingrese el correo electrónico</span>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="form-group">
                                            <label htmlFor="phone" className="col-form-label col-form-label-sm">
                                                Teléfono
                                            </label>
                                            <input
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese teléfono (Opcional)"
                                                type='tel'
                                                value={phone}
                                                onChange={(e) => setPhone(e.target.value)}
                                                id="phone"
                                                name="phone"
                                            />
                                            <span className="add-package-field-hint">Ingrese el número de teléfono</span>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-3">
                                        <div className="form-group">
                                            <label htmlFor="price" className="col-form-label col-form-label-sm">
                                                Precio de envio <span className="add-package-required">*</span>
                                            </label>
                                            <input
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese precio de envío"
                                                type='text'
                                                value={unformatCurrency(price)}
                                                onChange={(e) => handleCurrencyInput(e.target.value, setPrice)}
                                                onBlur={() => setPrice(unformatCurrency(price))}
                                                id="price"
                                                name="price"
                                                required
                                            />
                                            <span className="add-package-field-hint">Ingrese el precio de envío</span>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-3">
                                        <div className="form-group">
                                            <label htmlFor="declared" className="col-form-label col-form-label-sm">
                                                Valor declarado <span className="add-package-required">*</span>
                                            </label>
                                            <input
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese valor declarado"
                                                type='text'
                                                value={unformatCurrency(declared)}
                                                onChange={(e) => handleCurrencyInput(e.target.value, setDeclared)}
                                                onBlur={() => setDeclared(unformatCurrency(declared))}
                                                id="declared"
                                                name="declared"
                                                required
                                            />
                                            <span className="add-package-field-hint">Ingrese el valor declarado</span>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-2 d-none">
                                        <div className="form-group" >
                                            <label htmlFor="courtesy" className="col-form-label col-form-label-sm">
                                                Cortesia <span className="add-package-required">*</span>
                                            </label>
                                            <div onChange={handleChangeCourtesy}>
                                                <input
                                                    type="radio"
                                                    value="1"
                                                    name="courtesy"
                                                /> SI
                                                <br />
                                                <input
                                                    type="radio"
                                                    value="2"
                                                    name="courtesy"
                                                    defaultChecked
                                                /> NO
                                            </div>
                                            <span className="add-package-field-hint">Seleccione si es cortesía</span>
                                        </div>
                                    </div>
                                    {/* Estatus de pago */}
                                    <div className="col-12 col-sm-4">
                                        <div className="form-group">
                                            <label className="col-form-label col-form-label-sm">
                                                Estatus de pago <span className="add-package-required">*</span>
                                            </label>
                                            <div onChange={handleChangePaymentStatus}>
                                                <div className="form-check">
                                                    <input
                                                        type="radio"
                                                        value="1"
                                                        name="payment_status"
                                                        className="form-check-input"
                                                        id="payment_due"
                                                    />
                                                    <label className="form-check-label" htmlFor="payment_due">
                                                        Por cobrar
                                                    </label>
                                                </div>
                                                <div className="form-check">
                                                    <input
                                                        type="radio"
                                                        value="2"
                                                        name="payment_status"
                                                        className="form-check-input"
                                                        id="payment_paid"
                                                        defaultChecked
                                                    />
                                                    <label className="form-check-label" htmlFor="payment_paid">
                                                        Pagado
                                                    </label>
                                                </div>
                                            </div>
                                            <span className="add-package-field-hint">Seleccione el estatus de pago</span>
                                        </div>
                                    </div>

                                    {/* Pago con tarjeta */}
                                    <div className="col-12 col-sm-4">
                                        <div className="form-group">
                                            <label className="col-form-label col-form-label-sm">
                                                Pago con tarjeta <span className="add-package-required">*</span>
                                            </label>
                                            <div>
                                                <div className="form-check">
                                                    <input
                                                        type="radio"
                                                        value="1"
                                                        name="card_payment"
                                                        className="form-check-input"
                                                        id="card_yes"
                                                        onChange={handleChangeCardPaymentStatus}
                                                    />
                                                    <label className="form-check-label" htmlFor="card_yes">
                                                        Sí
                                                    </label>
                                                </div>
                                                <div className="form-check">
                                                    <input
                                                        type="radio"
                                                        value="2"
                                                        name="card_payment"
                                                        className="form-check-input"
                                                        id="card_no"
                                                        onChange={handleChangeCardPaymentStatus}
                                                        defaultChecked
                                                    />
                                                    <label className="form-check-label" htmlFor="card_no">
                                                        No
                                                    </label>
                                                </div>
                                            </div>
                                            <span className="add-package-field-hint">Seleccione si fue pago con tarjeta</span>
                                        </div>
                                    </div>

                                    {/* Pago con transferencia */}
                                    <div className="col-12 col-sm-4">
                                        <div className="form-group">
                                            <label className="col-form-label col-form-label-sm">
                                                Pago con transferencia <span className="add-package-required">*</span>
                                            </label>
                                            <div>
                                                <div className="form-check">
                                                    <input
                                                        type="radio"
                                                        value="1"
                                                        name="cardPaymentTransfer"
                                                        className="form-check-input"
                                                        id="transfer_yes"
                                                        onChange={handleChangeCardPaymentTransferStatus}
                                                    />
                                                    <label className="form-check-label" htmlFor="transfer_yes">
                                                        Sí
                                                    </label>
                                                </div>
                                                <div className="form-check">
                                                    <input
                                                        type="radio"
                                                        value="2"
                                                        name="cardPaymentTransfer"
                                                        className="form-check-input"
                                                        id="transfer_no"
                                                        onChange={handleChangeCardPaymentTransferStatus}
                                                        defaultChecked
                                                    />
                                                    <label className="form-check-label" htmlFor="transfer_no">
                                                        No
                                                    </label>
                                                </div>
                                            </div>
                                            <span className="add-package-field-hint">Seleccione si fue pago con transferencia</span>
                                        </div>
                                    </div>

                                    <div className={`${payment_status == 2 ? 'd-none' : ''} col-12 col-sm-3`}>
                                        <label htmlFor="advance" className="col-form-label col-form-label-sm">
                                            Anticipo {payment_status == 2 ? '' : <span className="add-package-required">*</span>}
                                        </label>
                                        <input
                                            className={`form-control form-control-sm`}
                                            placeholder="Anticipo"
                                            type='text'
                                            value={unformatCurrency(advance)}
                                            onChange={(e) => handleCurrencyInput(e.target.value, setAdvance)}
                                            onBlur={() => setAdvance(unformatCurrency(advance))}
                                            id="advance"
                                            name="advance"
                                            required={payment_status == 2 ? false : true}
                                        />
                                        <span className="add-package-field-hint">Ingrese el anticipo</span>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="submit"
                                    className="btn btn-success">
                                    <i className="fa-regular fa-floppy-disk me-1"></i>
                                    Guardar
                                </button>
                                <button
                                    onClick={cancelPackage}
                                    id="closemodal"
                                    type="button"
                                    className="btn btn-danger"
                                    data-bs-dismiss="modal">
                                    <i className="fa-solid fa-ban me-1"></i>
                                    Cancelar
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div className="container-fluid">
                <ContentHeader title="Módulo de Paquetería" />
            </div>

            <div className="container-fluid">
                <div className="card">
                    <div className="card-header">
                        <div className="indications-header row">
                            <div className="col-md-7">
                                <h4 className="card-title m-0 page-title">
                                    <i className="bi bi-box-arrow-in-down me-2"></i> Agregar Paquete
                                </h4>
                            </div>
                            <div className="col-md-5" style={{ textAlign: "right" }}>
                                <Link to="/listado-paquetes" className="btn btn-secondary btn-sm me-1">
                                    <i className="fa-solid fa-list-check me-1"></i> Listado de paquetes
                                </Link>
                                <button
                                    onClick={() => window.location.reload()}
                                    className="btn btn-info btn-sm me-1"
                                    type="button">
                                    <i className="fa fa-refresh me-1"></i> Recargar
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="add-package-form-header">
                            <h6 className="add-package-form-title">
                                <i className="bi bi-funnel me-2"></i>Filtros de Búsqueda
                            </h6>
                            <p className="add-package-form-subtitle" style={{ borderBottom: "1px solid #dee2e6", paddingBottom: "0.5rem" }}>
                                Use los siguientes filtros para buscar paquetes disponibles
                            </p>
                        </div>
                        <form onSubmit={handleSearch} className="mb-4">
                            <div className="row mb-2">
                                <div className="col-12 d-flex gap-2 flex-wrap mb-2">
                                    <button
                                        type="button"
                                        className="btn btn-outline-primary btn-sm"
                                        onClick={() => handleQuickSearch(1, 1, 25)}
                                    >
                                        <i className="fa fa-bolt me-1"></i> Oaxaca - Salina Cruz
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-outline-success btn-sm"
                                        onClick={() => handleQuickSearch(2, 25, 1)}
                                    >
                                        <i className="fa fa-bolt me-1"></i> Salina Cruz - Oaxaca
                                    </button>
                                </div>
                            </div>
                            <div className="indications row">
                                <div className="form-group col-sm-2">
                                    <label htmlFor="branch_id" className="col-form-label col-form-label-sm">
                                        Base <span className="add-package-required">*</span>
                                    </label>
                                    <select
                                        className="form-control form-control-sm select2"
                                        id="branch_id"
                                        name="branch_id"
                                        required
                                    >
                                        <option selected value="">Seleccione base</option>
                                        {branchs.map((item, index) => (
                                            <option key={index} value={item.value}>{item.label}</option>
                                        ))}
                                    </select>
                                    <span className="add-package-field-hint">Seleccione la base de operaciones</span>
                                </div>
                                <div className="form-group col-sm-3">
                                    <label htmlFor="origin_id" className="col-form-label col-form-label-sm">
                                        Origen <span className="add-package-required">*</span>
                                    </label>
                                    <select
                                        className="form-control form-control-sm select2"
                                        id="origin_id"
                                        name="origin_id"
                                        required
                                    >
                                        <option selected value="">Seleccione origen</option>
                                        {origins.map((item, index) => (
                                            <option key={index} value={item.value}>{item.label}</option>
                                        ))}
                                    </select>
                                    <span className="add-package-field-hint">Seleccione el lugar de origen</span>
                                </div>
                                <div className="form-group col-sm-3">
                                    <label htmlFor="destination_id" className="col-form-label col-form-label-sm">
                                        Destino <span className="add-package-required">*</span>
                                    </label>
                                    <select
                                        className="form-control form-control-sm select2"
                                        id="destination_id"
                                        name="destination_id"
                                        required
                                    >
                                        <option selected value="">Seleccione destino</option>
                                        {destinations.map((item, index) => (
                                            <option key={index} value={item.value}>{item.label}</option>
                                        ))}
                                    </select>
                                    <span className="add-package-field-hint">Seleccione el lugar de destino</span>
                                </div>
                                <div className="form-group col-sm-2">
                                    <label htmlFor="date" className="col-form-label col-form-label-sm">
                                        Fecha <span className="add-package-required">*</span>
                                    </label>
                                    <DatePicker
                                        showIcon
                                        locale="es"
                                        selected={date}
                                        onChange={(date) => setDate(date)}
                                        minDate={new Date()}
                                        maxDate={date_max}
                                        className="form-control form-control-sm"
                                        dateFormat="dd, MMMM, yyyy"
                                    />
                                    <span className="add-package-field-hint">Seleccione la fecha de envío</span>
                                </div>
                                <div className="col-sm-2">
                                    <button
                                        type="submit"
                                        className="btn btn-primary mt-4">
                                        <i className="fa-solid fa-magnifying-glass me-1"></i> Buscar
                                    </button>
                                </div>
                            </div>
                        </form>
                        <table className="table table-hover main table-striped table-responsive">
                            <thead>
                                <tr>
                                    <th width="20%" className="text-left">Base</th>
                                    <th width="30%" className="text-left">Origen</th>
                                    <th width="30%" className="text-left">Destino</th>
                                    <th width="10%" className="text-center">Horario</th>
                                    <th width="10%" className="text-center">Fecha</th>
                                    <th width="20%" className="text-center">Opciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {search.map((item, index) => (
                                    <tr key={index}>
                                        <td>
                                            {item.base}
                                        </td>
                                        <td>
                                            {item.origin}
                                        </td>
                                        <td>
                                            {item.destination}
                                        </td>
                                        <td className="text-center">
                                            {formatTime(item.time)}
                                        </td>
                                        <td className="text-center">
                                            {formatDate(item.date)}
                                        </td>
                                        <td className="text-center">
                                            <div>
                                                <button
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#modal-default"
                                                    onClick={() => handleChooseTrip(item.schedule_id, item.origin, item.destination, item.date, item.time)}
                                                    className='btn btn-success btn-sm'>
                                                    <i className="fa-solid fa-arrow-right me-1"></i>Elegir
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Packages;